export default "__VITE_ASSET__CXRVuaix__"